/**
 *
 *
 *
 *
 *
 *
 *
 */
import { o_global } from "../common/namespaces";

import type { QBus, QBusEventMap } from "../lib/event-q-bus/q-bus/index.js";
import type { EventLoaderEvents } from "./event-loader.js";

export type {
  QBus,
  QBusEventEnum,
  QBusEventMap,
  QBusOptions,
  TopicName,
} from "../lib/event-q-bus/q-bus/index.js";
export type { QBusTopic, EventData, EventCallback } from "../lib/event-q-bus/utils/index.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export type GlobalEvents = QBusEventMap<EventLoaderEvents>;

/**
 *
 *
 */
export const events: OttoGlobal["events"] = o_global.events;

/**
 *
 *
 */
export const eventQBus: QBus = o_global.eventQBus;
